// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__2CUgz","modal":"Modal_modal__1vwov","close":"Modal_close__2EfR5","modalInner":"Modal_modalInner__3U10b","modalInput":"Modal_modalInput__9jlGW"};